module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "project-title"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('b', [_vm._v("Welcome to Tilda’s studio, filled with quilts and pillows that you will love making for every season.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We begin in spring with the Scrapflower Quilt and its matching pillow, bright with flowers in pinks, yellows, teals and greens. The Birdhouse Quilt continues the garden theme with sweet little birds and their houses against a sky of fresh blues. The bolder colours of summer are excitingly displayed in the Fan Flower Quilt, with lilacs and corals glowing against a deep blue. For autumn we revel in the fruity colours of plums, peaches and blueberries in the Plum Quilt and the Plum Garden Village Quilt, with its cute houses and rows of fruit trees. Finally, we reach the cool greys and blues of winter with the fun Happy Snowman Quilt and its matching pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On your journey through the seasons you will discover quilts and pillows suitable for a wide range of sewing abilities. You may prefer easy designs, such as the Four Block Quilt or Cosy Stripe Quilt. Or you might relish the challenge of the Cat and Bird Quilt and the Plum Party Quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We have used fabrics from several of the Tilda collections. Specific details are given for those used, however, any of them can be replaced with others in similar colours. Many of the quilts and pillows can also be made in alternate colourways and a visit to "), _c('a', {
    attrs: {
      "href": "http://www.tildasworld.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tildasworld.com")]), _vm._v(" will show these alternatives. The projects have been lavishly custom quilted but it will be easy for you to use simple home quilting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The instructions and illustrations are clear and comprehensive, so whatever project you choose to make is sure to be a success and add beauty to your home. I wish you joy in your quilting.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/IN-F1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/IN-F2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7537d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Introduction.vue
// module id = 66
// module chunks = 0